<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage && this.totalParticipants > 0">
      <div class="text-right">
        <p-button
          type="info"
          class="mr-2"
          @click="printReport"
        >
          Print
        </p-button>
      </div>
      <collapse>
        <collapse-item
          name="Unassigned"
          v-if="participants.Unassigned.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Unassigned</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Unassigned"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Beavers"
          v-if="participants.Beavers.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Beavers</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Beavers"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Bobwhites"
          v-if="participants.Bobwhites.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Bobwhites</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Bobwhites"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Eagles"
          v-if="participants.Eagles.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Eagles</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Eagles"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Foxes"
          v-if="participants.Foxes.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Foxes</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Foxes"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Owls"
          v-if="participants.Owls.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Owls</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Owls"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Bears"
          v-if="participants.Bears.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Bears</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Bears"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Buffaloes"
          v-if="participants.Buffaloes.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Buffaloes</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Buffaloes"
            />
          </div>
        </collapse-item>
        <collapse-item
          name="Antelopes"
          v-if="participants.Antelopes.length > 0"
        >
          <template v-slot:title>
            <span class="critter-title text-danger">Antelopes</span>
          </template>
          <div>
            <participant-bios-patrol
              :participants="participants.Antelopes"
            />
          </div>
        </collapse-item>
      </collapse>
    </div>
    <div v-else>
      There are currently no Participants registered for this course.
    </div>
    <participant-bios-print
      :participants="participants"
      v-show="showPrintItem"
      v-if="loading === false"
    />
  </div>
</template>

<script>
import scouterApi from '@/services/api/scouter'
import oops from '@/components/_main/oops.vue'
import ParticipantBiosPatrol from '@/components/scouters/participant-bios-patrol.vue'
import Collapse from '@/plugins/paper-components/collapse/collapse.vue'
import CollapseItem from '@/plugins/paper-components/collapse/collapse-item.vue'
import ParticipantBiosPrint from '@/components/scouters/participant-bios-print.vue'

export default {
  name: 'ParticipantBios',
  components: {
    oops,
    ParticipantBiosPatrol,
    Collapse,
    CollapseItem,
    ParticipantBiosPrint
  },
  data: function () {
    return {
      participants: null,
      loading: true,
      errormessage: null,
      printItem: '',
      showPrintItem: false,
      printOptions: {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/participant-bios.css'
        ]
      }
    }
  },
  mounted () {
    scouterApi
      .getParticipantBios(this.$root.courseKey)
      .then(x => {
        this.participants = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    totalParticipants: function () {
      return this.participants.Beavers.length + this.participants.Bobwhites.length +
        this.participants.Eagles.length + this.participants.Foxes.length +
        this.participants.Owls.length + this.participants.Bears.length +
        this.participants.Buffaloes.length + this.participants.Antelopes.length +
        this.participants.Unassigned.length
    }
  },
  methods: {
    onParticipantSelected: function (selectedScouterKey) {
      const path = '/staff/participant?s=' + selectedScouterKey + '&r=bio'
      this.$router.push(path)
    },
    printReport: function () {
      this.printItem = 'printParticipants'
      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper(this.printItem, this.printOptions)
        }
        this.printItem = ''
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.critter-title {
  padding-left: 10px;
  font-size: 1.75rem;
  margin-bottom: .5rem;
  line-height: 1.2;
}
</style>
